import React, { ChangeEvent, useEffect, useState } from 'react';
import cx from 'classnames';
import styles from './addGroup.module.scss';
import Slider from '../slider';
import Button from '../button';
import { Input } from '../input';

interface AddGroupSliderProps {
  creating: boolean;
  handleCreateGroup: (groupName: string) => void;
  handleClose: () => void;
}

export const AddGroupSlider = ({ creating, handleCreateGroup, handleClose }: AddGroupSliderProps) => {

  const [groupName, setGroupName] = useState<string>('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGroupName(e.target.value);
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleCreateGroup(groupName);
    }
  }


  return (
    <Slider.Dialog
      width="300"
      show={true}
      onClose={handleClose}
    >
      <Slider.Header
        title="create a new group"
        message="Time to categorize those assets—like organizing your sock drawer, but more important" />
      <Slider.Body>

        <Input autoFocus className={styles.input} value={groupName} placeholder="Add a group name..." onChange={handleChange} onKeyDown={handleKeyDown}/>

      </Slider.Body>

      <Slider.Actions>
        <Button variant="primary" icon='paperflite-tick' text={creating ? "Creating..." : "Create"} disabled={creating || groupName.trim() === ""} onClick={() => handleCreateGroup(groupName)}></Button>
        <Button variant="secondary" text="Cancel" disabled={creating} onClick={handleClose}></Button>
      </Slider.Actions>
    </Slider.Dialog>
  )
};